import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/thedesperatetrader/app/watcher/AutoRefresh.tsx");
;
import(/* webpackMode: "eager" */ "/opt/thedesperatetrader/node_modules/next/dist/client/link.js");
